import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FlatButton from 'material-ui/RaisedButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import RecoverIcon from 'material-ui/svg-icons/action/delete-forever';
import ActivateIcon from 'material-ui/svg-icons/action/power-settings-new';

import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import ConfirmDialog from '../components/ConfirmDialog';
import EndUserForm from '../components/EndUserForm';
import * as endUserActions from '../redux/modules/endUsers';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const propTypes = {
  modifyEndUser: PropTypes.func,
  fetchEndUser: PropTypes.func,
  endUser: PropTypes.object,
  t: PropTypes.func,
  params: PropTypes.any,
  currentUser: PropTypes.object,
  unloadCurrent: PropTypes.func,
  changeValidStatus: PropTypes.any,
  changeActivationStatus: PropTypes.any,
};

const defaultProps = {
  endUser: {},
};

class EndUserModify extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDialogOpened: false,
      dialogText: '',
      onDialogConfirm: () => {},
    };

    this.id = this.props.params.splat;
  }

  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchEndUser(this.id);
  }

  componentWillUnmount() {
    this.props.unloadCurrent();
  }

  /*
    Custom methods
   */
  onModifyEndUser = (values) => {
    this.props.modifyEndUser(values);
  };

  cancelConfigurationDialog = () => {
    this.setState({ confirmDialogOpened: false, onDialogConfirm: () => {} });
  };

  changeValidStatus = () => {
    if (!this.props.endUser) {
      return;
    }
    this.props.changeValidStatus(this.props.endUser.id, !this.props.endUser.valid);

    this.cancelConfigurationDialog();
  };

  changeActivationStatus = () => {
    if (!this.props.endUser) {
      return;
    }

    this.props.changeActivationStatus(this.props.endUser.id, true);
    // Code
    this.cancelConfigurationDialog();
  };

  render() {
    const { endUser } = this.props;

    let deleteButton = null;
    let activateButton = null;

    if (this.props.endUser) {
      if (this.props.endUser.valid) {
        deleteButton = (
          <FlatButton
            label={this.props.t('delete_user')}
            icon={<DeleteIcon />}
            onClick={() => {
              this.setState({
                confirmDialogOpened: true,
                onDialogConfirm: this.changeValidStatus,
                dialogText: this.props.t('delete_user_question'),
              });
            }}
          />
        );
      } else {
        deleteButton = (
          <FlatButton
            label={this.props.t('recover_user')}
            icon={<RecoverIcon />}
            onClick={() => {
              this.setState({
                confirmDialogOpened: true,
                onDialogConfirm: this.changeValidStatus,
                dialogText: this.props.t('recover_user_question'),
              });
            }}
          />
        );
      }

      if (
        this.props.currentUser &&
        this.props.currentUser.role === 'SUPER_ADMIN' &&
        !this.props.endUser.is_active
      ) {
        activateButton = (
          <FlatButton
            label={this.props.t('activate_user')}
            icon={<ActivateIcon />}
            onClick={() => {
              this.setState({
                confirmDialogOpened: true,
                onDialogConfirm: this.changeActivationStatus,
                dialogText: this.props.t('activate_user_question'),
              });
            }}
          />
        );
      }
    }

    const rightComponent = (
      <div>
        {activateButton} {deleteButton}
      </div>
    );

    return (
      <PageBase title={this.props.t('modify_user')} rightComponent={rightComponent}>
        <div>
          <EndUserForm onSubmit={this.onModifyEndUser} isModify initialValues={endUser} />
          <ConfirmDialog
            open={this.state.confirmDialogOpened}
            text={this.state.dialogText}
            onConfirm={this.state.onDialogConfirm}
            onCancel={this.cancelConfigurationDialog}
          />
        </div>
      </PageBase>
    );
  }
}

EndUserModify.defaultProps = defaultProps;
EndUserModify.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    endUser: state.endUsers.current,
    currentUser: state.auth.current,
  };
}

const extended = translate(['translations'], { i18n })(EndUserModify);
export default connect(mapStateToProps, endUserActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/EndUserModify.js